import {Card} from '../../../../game_table/table_objects/stacks/Card';
import {Stack} from '../../../../game_table/table_objects/stacks/Stack';
import {PieMenuIcons} from '../../PieMenuIcons';

export enum SubmenuType
{
    PLAYER,
    NUMBER
}

export interface IPieMenuCommand
{
    iconId: PieMenuIcons,
    hint: string,
    hasSubmenu?: boolean,
    submenuType?: SubmenuType
}

export class CommandStrategy
{
    constructor(public command: IPieMenuCommand) {

    }

    /**
     * Функция возвращает булево значение, о применимости данной стратегии
     * @param cards - карты в руке
     * @param stack - колоды на столе
     */
    isApplicable(cards: Card | undefined, stack: Stack | undefined): boolean {
        throw new Error('must override in subclass');
    }

    /**
     * Выполняет комманду данный стратегии
     * @param commandIndex - индекс для меню второго уровня
     */

    execute(commandIndex: number): void {
        throw new Error('must override in subclass');
    }

    /**
     * количество пунктов подменю
     */
    getTier2CommandsCount(): number {
        return -1;
    }
}
